var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5 58.0834C37.6296 58.0834 40.1667 55.5464 40.1667 52.4167C40.1667 51.6343 40.8009 51.0001 41.5833 51.0001C42.3657 51.0001 43 51.6343 43 52.4167C43 57.1112 39.1944 60.9167 34.5 60.9167C29.8056 60.9167 26 57.1112 26 52.4167C26 51.6343 26.6343 51.0001 27.4167 51.0001C28.1991 51.0001 28.8333 51.6343 28.8333 52.4167C28.8333 55.5464 31.3704 58.0834 34.5 58.0834Z",
    fill: "#33CCBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7254 45.3333H53.2751C55.2539 45.3333 56.3396 43.0302 55.0804 41.5038L52.9702 38.946C52.3863 38.2383 52.067 37.3494 52.067 36.4319V28.9C52.067 19.1982 44.2021 11.3333 34.5003 11.3333C24.7985 11.3333 16.9337 19.1982 16.9337 28.9V36.4319C16.9337 37.3494 16.6143 38.2383 16.0304 38.9461L13.9202 41.5039C12.661 43.0302 13.7467 45.3333 15.7254 45.3333ZM34.5003 8.5C23.2337 8.5 14.1003 17.6334 14.1003 28.9V36.4319C14.1003 36.6914 14.01 36.9428 13.8449 37.143L11.7347 39.7008C8.95086 43.075 11.351 48.1667 15.7254 48.1667H53.2751C57.6495 48.1667 60.0497 43.0751 57.2659 39.7008L55.1558 37.143C54.9907 36.9428 54.9003 36.6914 54.9003 36.4319V28.9C54.9003 17.6334 45.767 8.5 34.5003 8.5Z",
    fill: "#33CCBD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.777d76e10325700737f966c6a7ee08a9.svg";
export { ForwardRef as ReactComponent };